// translations.js
export const englishPackingListTranslations = {
  packingListTitle: "PACKING LIST",
  plNumberLabel: "Packing List No.:",
  dateLabel: "Date:",
  senderTitle: "Sender Information:",
  receiverTitle: "Receiver Information:",
  senderCompanyLabel: "Company:",
  senderRegLabel: "Registration:",
  senderVatLabel: "VAT:",
  senderLegalAddressLabel: "Legal Address:",
  senderDeliveryAddressLabel: "Delivery Address:",
  receiverCompanyLabel: "Company:",
  receiverRegLabel: "Registration:",
  receiverVatLabel: "VAT:",
  receiverLegalAddressLabel: "Legal Address:",
  receiverDeliveryAddressLabel: "Delivery Address:",
  colNo: "#",
  colName: "Product",
  colQty: "Qty",
  colWeight: "Weight",
  colBoxes: "Boxes",
  commentLabel: "Comment:",
}

export const latvianPackingListTranslations = {
  packingListTitle: "IEPAKOŠANAS SARAKSTS",
  plNumberLabel: "Iepakošanas saraksta Nr.:",
  dateLabel: "Datums:",
  senderTitle: "Sūtītāja informācija:",
  receiverTitle: "Saņēmēja informācija:",
  senderCompanyLabel: "Uzņēmums:",
  senderRegLabel: "Reģ.nr.:",
  senderVatLabel: "PVN:",
  senderLegalAddressLabel: "Juridiskā adrese:",
  senderDeliveryAddressLabel: "Piegādes adrese:",
  receiverCompanyLabel: "Uzņēmums:",
  receiverRegLabel: "Reģ.nr.:",
  receiverVatLabel: "PVN:",
  receiverLegalAddressLabel: "Juridiskā adrese:",
  receiverDeliveryAddressLabel: "Piegādes adrese:",
  colNo: "#",
  colName: "Produkts",
  colQty: "Daudzums",
  colWeight: "Svars",
  colBoxes: "Kastes",
  commentLabel: "Komentārs:",
}
